import { render, staticRenderFns } from "./CollaboratorForm.vue?vue&type=template&id=1bbaf641&"
import script from "./CollaboratorForm.vue?vue&type=script&lang=js&"
export * from "./CollaboratorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports